import { useDrawFeature, useDrawingContext } from '@ais-ui/react-openlayers';

export function useDrawings() {
  const drawingContext = useDrawingContext();

  const { undo, clearDrawing, finishDrawing, replaceFeature } = useDrawFeature(
    drawingContext.geometryType,
    drawingContext.onDraw.current,
    drawingContext.onDraw.current,
    drawingContext.existingFeature.current,
    drawingContext.setIsValidDrawing,
    drawingContext.drawingStyle,
    drawingContext.maxPoints,
    drawingContext.setRadius,
    drawingContext.validateWhileDrawing
  );

  drawingContext.undo.current = undo;
  drawingContext.clearDrawing.current = clearDrawing;
  drawingContext.finishDrawing.current = finishDrawing;
  drawingContext.replaceFeature.current = replaceFeature;
}
